export const MuiDialogTitle = () => ({
  root: {
    padding: 30
  }
});
